import config from "config/config";
export async function getConsentPDFContent(FileName, Display) {
  const queryString =
    FileName !== "" ? `FileName=${FileName}&Display=${Display}` : "";

  const options = {
    method: "GET",
    headers: {
      Accept: "text/html",
      "Content-Type": "application/json",
      ClientSecret: config.PORTAL_CLIENT_SECRET,
    },
  };
  const response = await fetch(
    config.REG_API_BASE_URL + "/User/document?" + queryString,
    options
  );
  if (response.ok) {
    return response.text();
  } else {
    console.log(response);
  }
}
